import axios from "axios";
import moment from "moment";

export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? `${window.location.href.substring(
        0,
        window.location.href.indexOf("3000")
      )}9000`
    : process.env.REACT_APP_API_ENDPOINT;

export function getPetData() {
  const url = `${BASE_URL}/data/sample.json`;
  return axios.get(url).then(response => response.data);
}

export function forceInputLowercase(e) {
  var start = e.target.selectionStart;
  var end = e.target.selectionEnd;
  e.target.value = e.target.value.toLowerCase();
  e.target.setSelectionRange(start, end);
}
export function forceInputUppercase(e) {
  var start = e.target.selectionStart;
  var end = e.target.selectionEnd;
  e.target.value = e.target.value.toUpperCase();
  e.target.setSelectionRange(start, end);
}

export function resizeImage(img, width, height) {
  // create an off-screen canvas
  var canvas = document.createElement('canvas'),
  ctx = canvas.getContext('2d');

  // set its dimension to target size
  canvas.width = (img.width > width) ? width : img.width;
  canvas.height = (img.height > height) ? height : img.height;

  // draw source image into the off-screen canvas:
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  // encode image to data-uri with base64 version of compressed image
  return canvas.toDataURL("image/jpeg");
}

//this function is use format dates to us format(resolve safari format issues)
export function changeDateFormat(date, currentFormat, requestFormat, delimiter = "-") {
    if (moment.isMoment(date)) {
      return date.format(requestFormat);
    } else {
      let currentDateArr = date.split(delimiter);
      let currentFormatArr = currentFormat.split(delimiter);
      let requestFormatArr = requestFormat.split(delimiter);
  
      if (currentDateArr.length > 2 && currentFormatArr.length > 2 && requestFormatArr.length > 2) {
        let currentDD, currentMM, currentYYYY;
        for (let i = 0; i < currentFormatArr.length; i++) {
          if (currentFormatArr[i] === "DD") {
            currentDD = i;
          }
          if (currentFormatArr[i] === "MM") {
            currentMM = i;
          }
          if (currentFormatArr[i] === "YYYY") {
            currentYYYY = i;
          }
        }
  
        let newDate = "";
        
        let requestDD, requestMM, requestYYYY;
        for (let i = 0; i < requestFormatArr.length; i++) {
          if (requestFormatArr[i] === "DD") {
            requestDD = currentDateArr[currentDD];
            newDate += requestDD;
            if ((requestFormatArr.length - 1) > i) {
              newDate += delimiter;
            }
          }
          if (requestFormatArr[i] === "MM") {
            requestMM = currentDateArr[currentMM];
            newDate += requestMM;
            if ((requestFormatArr.length - 1) > i) {
              newDate += delimiter;
            }
          }
          if (requestFormatArr[i] === "YYYY") {
            requestYYYY = currentDateArr[currentYYYY];
            newDate += requestYYYY;
            if ((requestFormatArr.length - 1) > i) {
              newDate += delimiter;
            }
          }
        }
        return newDate;
      }
    }
  }

export function formatPhoneNumber(phoneNumberString){
  if(phoneNumberString){
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    let match = cleaned.match(/^(\d{1,3}|)?(\d{3})(\d{3})(\d{4})$/);
     if (match) {
      let intlCode = (match[1] ? `+${match[1]} ` : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return phoneNumberString;
  }
  else{
    return null;
  }
}

export function convertToTitleCase(str) {
  if (!str) {
      return "";
  }
  return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}